import { getTaxesTextPair } from './chunk-OMVDHYS5.mjs';
import { menuTypeCardFactory } from './chunk-CNNXVQ5L.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/factories/mainScreenTables/menuTypesTableFactory.ts
var menuTypesTableFactoryCore = (menuTypes, taxes) => {
  return Object.values(menuTypes).map((menuType) => {
    const menuTypeCoreCard = menuTypeCardFactory({
      [menuType.menuTypeId]: menuType
    })[0];
    return __spreadProps(__spreadValues({}, menuTypeCoreCard), {
      comboCount: menuType.comboIds.length,
      categoryCount: menuType.categoryIds.length,
      subcategoryCount: menuType.subcategoryIds.length,
      enableSimpleMode: menuType.enableSimpleMode,
      coursingType: menuType.coursingType,
      taxes: getTaxesTextPair(menuType.taxIds, taxes)
    });
  });
};

export { menuTypesTableFactoryCore };
